import { createContext } from 'react';

const StickyHeader = createContext(null);

export default StickyHeader;

